export const P2E_ERROR_CODES = {
  duplicateSubmission: 'p2e.errors.duplicateSubmission',
} as const;

export type P2EErrorCode = keyof typeof P2E_ERROR_CODES;
export type P2EErrorKey = (typeof P2E_ERROR_CODES)[P2EErrorCode];

const P2E_ERROR_KEY_SET = new Set<P2EErrorKey>(Object.values(P2E_ERROR_CODES));

export function isP2EErrorKey(value: unknown): value is P2EErrorKey {
  return typeof value === 'string' && P2E_ERROR_KEY_SET.has(value as P2EErrorKey);
}





